module.exports = __webpack_public_path__ + "files/a5a9ebd68768100c5a2523e67d94984d.png";